import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from '@hooks/useTranslation';

const FormPreviewPage = lazy(() => import('@features/form-builder/FormPreviewPage'));

function FormPreviewRoute() {
  const { t } = useTranslation();
  return (
    <Suspense
      fallback={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
          {t('K_LOADING_FORM_PREVIEW', 'Loading form preview...')}
        </div>
      }
    >
      <FormPreviewPage />
    </Suspense>
  );
}

export const Route = createFileRoute('/w/form/preview')({
  component: FormPreviewRoute,
});
